/**
 * Tkadlec Snu API client — separate base URL, same auth token.
 */
import { notifyAuthExpired } from "./authSession";

const TKADLEC_API_BASE = import.meta.env.VITE_TKADLEC_API_URL || "";

async function request(method, path, body = null) {
  const token = localStorage.getItem("anna_token");
  const headers = { "Content-Type": "application/json" };
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const options = { method, headers };
  if (body) {
    options.body = JSON.stringify(body);
  }

  const response = await fetch(`${TKADLEC_API_BASE}${path}`, options);

  if (!response.ok) {
    if (response.status === 401) notifyAuthExpired("unauthorized");
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || error.message || `HTTP ${response.status}`);
  }

  return response.json();
}

export const tkadlecApi = {
  // Context
  getContextSummary: () => request("GET", "/context-summary"),

  // Settings
  getSettings: () => request("GET", "/settings"),
  updateSettings: (settings) => request("PUT", "/settings", settings),

  // Prompts
  getPrompts: () => request("GET", "/prompts"),
  updatePrompts: (prompts) => request("PUT", "/prompts", prompts),

  // Shadow memories
  getMemories: ({ status = "", cursor = "", limit = 50, ...filters } = {}) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (status) params.set("status", status);
    if (cursor) params.set("cursor", cursor);
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== "" && value !== null && value !== undefined) params.set(key, String(value));
    });
    return request("GET", `/memories?${params.toString()}`);
  },
  getMemoryUsage: () => request("GET", "/memory-usage"),
  getMemory: (id) => request("GET", `/memories/${encodeURIComponent(id)}`),
  updateMemory: (id, updates) => request("PATCH", `/memories/${encodeURIComponent(id)}`, updates),
  deleteMemory: (id, expectedVersion) => request(
    "DELETE",
    `/memories/${encodeURIComponent(id)}`,
    { expectedVersion },
  ),
  getMemoryJobs: ({ cursor = "", limit = 25 } = {}) => {
    const params = new URLSearchParams({ limit: String(limit) });
    if (cursor) params.set("cursor", cursor);
    return request("GET", `/memory-jobs?${params.toString()}`);
  },
};
